import { Box, replaceSpecialChar } from '@stars-ecom/shared-atoms-ui'
import React from 'react'
const MondialRelayErrorMessage = ({ message }) => (
  <Box p="10px" m="10px" color="#204a8e" bg="#c9ddff" border="1px solid #4c699b">
    {replaceSpecialChar(message)}
  </Box>
)

export default MondialRelayErrorMessage
